import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RestService } from '../lib/RestService';
import { CatalogItem } from '../catalog/catalog.service';

@Injectable()
export class CompareService extends RestService {
  compare: CatalogItem[] = [];
  private apiUrl = `${environment.apiUrl}shop/Compare/`;

  constructor(private http: HttpClient) {
      super();
      this.updateCompare();
  }

  public async updateCompare() {
    try {
      this.compare = await this.get();
      return this.compare;
    } catch (e) {}
  }

  public get(name?: string): Promise<CatalogItem[] | any> {
    const apiUrl = name ? `${this.apiUrl}?name=${name}` : this.apiUrl;
    return this.http.get<CatalogItem[]>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }

  public getLists(): Promise<string[] | any> {
    return this.http.get<CatalogItem[]>(`${this.apiUrl}lists`, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }

  public async add(id: string, name?: string): Promise<any> {
    const apiUrl = name ? `${this.apiUrl}${id}?name=${name}` : `${this.apiUrl}${id}`;
    try {
      const result = await this.http.post<CatalogItem>(apiUrl, {}, {withCredentials: true}).toPromise();
      await this.updateCompare();
      return result;
    } catch (e) {
      this.handleError(e);
    }
  }

  public async delete(id: string, name?: string): Promise<any> {
    const apiUrl = name ? `${this.apiUrl}${id}?name=${name}` : `${this.apiUrl}${id}`;
    try {
      const result = await this.http.delete<CatalogItem>(apiUrl, {withCredentials: true}).toPromise();
      await this.updateCompare();
      return result;
    } catch (e) {
      this.handleError(e);
    }
  }
}
